// extracted by mini-css-extract-plugin
export default {"new-quote-form":"NewQuote_new-quote-form__6EtJu"};